import React, { useState, useEffect } from "react";
import { FaUserPlus, FaChalkboardTeacher, FaTimes } from "react-icons/fa";
import "../css/FloatingMenu.css";

// Import your tab-specific images here
import diagnosticImg from "../../images/service1.png";
import lmsImg from "../../images/service2.png";
import schoolImg from "../../images/service3.png";
import instituteImg from "../../images/service4.png";
import admissionImg from "../../images/service5.png";
import forumImg from "../../images/service6.png";
import kirnavaliImg from "../../images/kirnavaliicon.png";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import emailjs from "emailjs-com";
const MySwal = withReactContent(Swal);

function FloatingMenu() {
    const [modalOpen, setModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    const [referralBy, setReferralBy] = useState(null);
    // Detect referral
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const ref = params.get("ref");
        if (ref) setReferralBy(ref);
    }, []);

    // Tab configuration with unique images per tab
    const serviceTabs = [
        {
            name: "Free Diagnostic Test",
            image: diagnosticImg,
            pointers: [
                "Free chapter-wise practice tests & concept maps",
                "AI-generated performance insights & report card",
                "Strength & weakness analysis with study plan",
                "Time, accuracy & chapter-wise progress tracking"
            ],
            linkText: "Start Free Diagnostic Test",
            linkUrl: "https://lms.crestest.com/page-login"
        },
        {
            name: "Complete CBSE & ICSE Curriculum Mastery",
            image: lmsImg,
            pointers: [
                "Unlimited premium chapter-wise & full-length tests",
                "AI-powered analytics with personalized study plans",
                "Adaptive question engine & weak area detection",
                "Exam-ready simulations with parent growth insights"
            ],
            linkText: "Explore Premium Learning",
            linkUrl: "https://lms.crestest.com/page-login"
        },
        {
            name: "School Management",
            image: schoolImg,
            pointers: [
                "Digital admission & enrollment workflow",
                "Learning management, assignments & online exams",
                "Student performance analytics & AI-ready report cards",
                "Role-based administration with enterprise security"
            ],
            linkText: "Explore School ERP",
            linkUrl: "https://school.crestest.com"
        },
        {
            name: "Institute Management",
            image: instituteImg,
            pointers: [
                "Smart admission pipeline & document management",
                "Lecture hosting, LMS & assignment automation",
                "Online exams with proctoring & instant evaluation",
                "Analytics, audit trails & role-based administration"
            ],
            linkText: "Explore Institute ERP",
            linkUrl: "https://software.crestest.com"
        },
        {
            name: "Admission Management",
            image: admissionImg,
            pointers: [
                "Smart lead capture & digital admission forms",
                "Secure document verification & interview scheduling",
                "Real-time application tracking & fee collection",
                "Instant receipts with automated payment reconciliation"
            ],
            linkText: "Manage Admissions",
            linkUrl: "https://software.crestest.com"
        },
        {
            name: "Forum",
            image: forumImg,
            pointers: [
                "Create public & private posts with discussions",
                "Like, comment, share & connect with learners",
                "Community quizzes, leaderboards & badges",
                "Notifications, moderation & hashtag discovery"
            ],
            linkText: "Join Scholars' Forum",
            linkUrl: "https://forum.crestest.com/"
        },
        {
            name: "Kirnavali",
            title: "Kirnavali National Challenge Portal",
            image: kirnavaliImg,
            pointers: [
                "Nationwide academic challenges and competitions",
                "Comprehensive performance analysis and insights",
                "Skill-based testing to measure true growth",
                "Competitive leaderboards and national rankings"
            ],
            linkText: "Join National Challenge",
            linkUrl: "https://staging-kirnavali.crestestlearning.com"
        }
    ];

    // Helper function to handle link redirection and close modal
    const handleLinkAction = (tabIndex) => {
        window.open(serviceTabs[tabIndex].linkUrl, '_blank');
        setModalOpen(false);
    };

    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            if (documentHeight - (scrollTop + windowHeight) < 150) {
                setIsVisible(false);
            } else {
                setIsVisible(true);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    if (!isVisible) return null;

    const openPreRegisterPopup = () => {
        Swal.fire({
            html: `
        <div class="crestest-prereg-popup">
            <button class="crestest-prereg-close">✕</button>
            <h2 class="crestest-prereg-title">Your Journey Continues...</h2>
            <p class="crestest-prereg-subtitle">
                Choose how you want to proceed with your Crestest learning path?
            </p>
            <div class="crestest-prereg-divider"></div>
            <div class="crestest-prereg-row">
                <div class="crestest-prereg-box">
                    <h3>I Want to Register for the Premium Portal</h3>
                    <p>Unlock complete learning experience with premium courses, advanced assessments, analytics, and mock exams.</p>
                    <button class="crestest-prereg-btn crestest-prereg-btn-premium">
                        ACCESS PREMIUM LMS
                    </button>
                </div>
                <div class="crestest-prereg-box">
                    <h3>Start with Free Portal</h3>
                    <p>Start free journey and explore study materials and mock generators.</p>
                    <button class="crestest-prereg-btn crestest-prereg-btn-free">
                        CONTINUE FREE REGISTRATION
                    </button>
                </div>
            </div>
        </div>
        `,
            showConfirmButton: false,
            showCancelButton: false,
            heightAuto: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            background: "transparent",
            backdrop: `
                rgba(15, 23, 42, 0.8)
                backdrop-filter: blur(16px);
                -webkit-backdrop-filter: blur(16px);
            `,
            customClass: {
                popup: "crestest-prereg-swal"
            },
            didOpen: () => {
                document.body.style.overflow = 'hidden';
                document
                    .querySelector(".crestest-prereg-close")
                    .addEventListener("click", () => Swal.close());

                document
                    .querySelector(".crestest-prereg-btn-premium")
                    .addEventListener("click", () => {
                        window.open("https://lms.crestest.com/page-register", "_blank");
                    });

                document
                    .querySelector(".crestest-prereg-btn-free")
                    .addEventListener("click", () => {
                        Swal.close();
                        openRegisterPopup();
                    });
            }
        });
    };

    const generatePassword = () => {
        return Math.random().toString(36).slice(-8) + "A1!";
    };

    const openRegisterPopup = () => {
        let captchaText = Math.random().toString(36).substring(2, 8).toUpperCase();

        MySwal.fire({
            html: `
    <div class="form-container"
      style="background-color:#ecbb0c;
      border-radius:15px;
      padding:20px;
      box-shadow:0 8px 20px rgba(0,0,0,0.4);
      max-height:75vh;
      overflow-y:auto;
      text-align:left;">

      <h3 style="font-size:1.5rem; margin-bottom:10px;">Register yourself!</h3>
      <p style="font-size:0.8rem; text-align:right;">* All fields are required</p>

      <form id="registrationForm">

        <div class="row">
          <div class="col-md-6 mb-2">
            <input class="form-control" name="username" type="text" placeholder="Username" required />
          </div>
          <div class="col-md-6 mb-2">
            <input class="form-control" name="phone" type="tel" placeholder="Phone (Optional)" />
          </div>
        </div>

        <div class="mb-2">
          <input class="form-control" name="email" type="email" placeholder="Email" required />
        </div>

        <div class="mb-3">
          <label style="font-weight:600;">Captcha Verification</label>

          <div style="
            display:flex;
            justify-content:space-between;
            align-items:center;
            background:#fff;
            border-radius:8px;
            padding:10px;
            box-shadow:inset 0 0 5px rgba(0,0,0,0.3);
            font-size:20px;
            letter-spacing:3px;
            font-weight:bold;">
            <span id="captchaValue">${captchaText}</span>
            <button type="button" id="refreshCaptcha"
              style="background:#720f0f;color:#fff;border:none;padding:5px 10px;border-radius:5px;">
              ↻
            </button>
          </div>

          <input class="form-control mt-2" id="captchaInput" type="text" placeholder="Enter captcha" required />
        </div>

        <div class="form-check mb-3">
          <input type="checkbox" class="form-check-input" id="acceptTerms" />
          <label class="form-check-label" style="font-size:15px;">
            I agree with the
            <a href="/terms-and-conditions" style="color:#720f0f;"> Terms & Conditions </a>
          </label>
        </div>

        <button type="submit" id="submitBtn" class="btn w-100"
          style="background-color:#720f0f;border:none;color:white;"
          disabled>
          Submit
        </button>
      </form>
    </div>
    `,
            didOpen: () => {
                document.body.style.overflow = 'hidden';

                document.getElementById("refreshCaptcha").onclick = () => {
                    captchaText = Math.random().toString(36).substring(2, 8).toUpperCase();
                    document.getElementById("captchaValue").textContent = captchaText;
                };

                const submitBtn = document.getElementById("submitBtn");
                const termsCheckbox = document.getElementById("acceptTerms");

                termsCheckbox.addEventListener("change", () => {
                    submitBtn.disabled = !termsCheckbox.checked;
                });

                const form = document.getElementById("registrationForm");

                form.addEventListener("submit", async (e) => {
                    e.preventDefault();

                    const username = form.querySelector('[name="username"]').value.trim();
                    const phoneInput = form.querySelector('[name="phone"]').value.trim();
                    const phone = phoneInput !== "" ? phoneInput : null;
                    const email = form.querySelector('[name="email"]').value.trim();
                    const generatedPassword = generatePassword();
                    const userCaptcha = document.getElementById("captchaInput").value.trim();

                    if (userCaptcha !== captchaText) {
                        Swal.showValidationMessage("Captcha incorrect!");
                        return;
                    }

                    try {
                        Swal.fire({
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showConfirmButton: false,
                            didOpen: () => Swal.showLoading()
                        });

                        await emailjs.send(
                            "service_5jka6tl",
                            "template_zf7rzyp",
                            {
                                to_email: email,
                                to_name: username,
                                user_password: generatedPassword,
                            },
                            "eIT-K7P86ilwuE-Dc"
                        );

                        Swal.close();

                        Swal.fire({
                            icon: "success",
                            title: "Registration Successful!",
                            text: "Verification email sent. Please check your inbox.",
                            confirmButtonColor: "#720f0f"
                        });

                    } catch (err) {
                        Swal.fire({
                            icon: "error",
                            title: "Registration Failed",
                            text: err.message,
                            confirmButtonColor: "#720f0f"
                        }).then(() => {
                            openRegisterPopup();
                        });
                    }
                });
            },
            showConfirmButton: false,
            width: "400px",
            background: "transparent"
        });
    };

    return (
        <>
            <div className="crest-floater-container">
                <button
                    type="button"
                    onClick={openPreRegisterPopup}
                    className="crest-floater-btn floater-blue border-0"
                    title="Register Here"
                >
                    <FaUserPlus className="floater-icon" />
                    <span className="floater-label">Register</span>
                </button>

                <button
                    type="button"
                    onClick={() => setModalOpen(true)}
                    className="crest-floater-btn floater-yellow border-0"
                    title="Teacher & Services"
                >
                    <FaChalkboardTeacher className="floater-icon" />
                    <span className="floater-label">Domains</span>
                </button>
            </div>

            {modalOpen && (
                <div className="crest-modal-backdrop">
                    <div className="crest-modal-card glass-morphic-modal">

                        <button
                            className="crest-modal-close"
                            onClick={() => setModalOpen(false)}
                        >
                            <FaTimes />
                        </button>

                        <div className="crest-modal-header-group text-center">
                            <p className="modal-small-txt">Explore Our Ecosystem</p>
                            <h2 className="modal-heading-txt">Comprehensive Learning & Management Solutions</h2>
                            <p className="modal-sub-txt">
                                Empowering students, educators, and institutions with cutting-edge digital infrastructure designed for academic excellence.
                            </p>
                        </div>

                        <div className="crest-modal-tabs-container">
                            {serviceTabs.map((tab, index) => (
                                <button
                                    key={index}
                                    className={`crest-modal-tab-btn ${activeTab === index ? 'active-tab' : ''}`}
                                    onClick={() => setActiveTab(index)}
                                >
                                    {tab.name}
                                </button>
                            ))}
                        </div>

                        <div className="crest-modal-body-split">

                            <div className="modal-split-left">
                                <h4 className="split-section-title">Key Capabilities</h4>
                                <ul className="modal-pointers-list">
                                    {serviceTabs[activeTab].pointers.map((pointer, i) => (
                                        <li key={i} className="pointer-item">
                                            <span className="pointer-bullet">✓</span> {pointer}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="modal-split-right">
                                <div className="modal-image-wrapper">
                                    <img
                                        src={serviceTabs[activeTab].image}
                                        alt={serviceTabs[activeTab].name}
                                        className="img-fluid modal-preview-img"
                                    />
                                </div>
                                <button
                                    onClick={() => handleLinkAction(activeTab)}
                                    className="btn crest-goto-btn"
                                >
                                    {serviceTabs[activeTab].linkText} →
                                </button>
                            </div>

                        </div>

                    </div>
                </div>
            )}
        </>
    );
}

export default FloatingMenu;